import axios from 'axios';
import {
  FETCH_ORDERS,
  CREATE_ORDER,
  CLEAR_CART,
  CLEAR_ORDER,
  DELETE_ORDER,
} from '../types';
import { notification, sumCartPrice } from '../../utils';

export const createOrder = (orderDetail) => async (dispatch, getState) => {
  const { items } = getState().cartItems;
  const itemRemovedDetail = JSON.parse(
    localStorage.getItem('shopprs_cartItemsRemoved')
  );

  try {
    const createOrder = await axios.post('/api/orders', {
      orderDetail: {
        ...orderDetail,
        total: sumCartPrice(items),
        cartItems: items,
      },
      itemRemovedDetail,
    });
    const getOrder = createOrder.data;

    dispatch({
      type: CREATE_ORDER,
      payload: getOrder,
    });
    localStorage.removeItem('shopprs_cartItems');
    localStorage.removeItem('shopprs_cartItemsRemoved');

    dispatch({ type: CLEAR_CART });
    notification('success', `Order created!`);
  } catch (error) {
    notification('error', 'An error occured!');
  }
};

export const clearOrder = () => (dispatch) => {
  dispatch({ type: CLEAR_ORDER });
};

export const fetchOrders = () => async (dispatch) => {
  try {
    const allOrders = await axios.get('/api/orders');
    const getOrders = await allOrders.data;
    dispatch({
      type: FETCH_ORDERS,
      payload: getOrders,
    });
  } catch (error) {
    notification('error', 'An error occured!');
  }
};

export const deleteOrder = (id) => async (dispatch, getState) => {
  const {
    orders: { items: orderItems },
  } = getState();

  try {
    const deletedOrder = await axios.delete(`/api/orders/${id}`);
    const deletedItem = deletedOrder.data;

    dispatch({
      type: DELETE_ORDER,
      payload: orderItems.slice().filter((i) => i._id !== deletedItem._id),
    });
    notification('success', `order deleted!`);
  } catch (err) {
    notification('error', 'An error occured!');
  }
};
